export const VUE_APP_BASEURL = process.env.VUE_APP_BASEURL || 'https://api-ittara.dafa.dev/v1/'

// export const VUE_APP_FRONT_MARKETPLACE_LINK = process.env.VUE_APP_FRONT_MARKETPLACE_LINK || 'https://seller.apothecary.dafa.dev/login'
export const VUE_APP_FRONT_MARKETPLACE_LINK = process.env.VUE_APP_ADMIN_BASEURL || 'http://172.16.40.121:9000/v1/login'
